import { useContext } from 'react';
import GlobalStateContext from '../../context/GlobalStateContext';

function useSchools() {
  const { schools, transcriptSelectionSchool, dataQcSchool, updateTranscriptSelectionSchool, updateDataQcSchool } =
    useContext(GlobalStateContext);

  return { schools, transcriptSelectionSchool, dataQcSchool, updateTranscriptSelectionSchool, updateDataQcSchool };
}

export default useSchools;
